export const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export const formatGallons = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = Number(value);
    if (isNaN(num)) return value;
    const rounded = Math.round(num * 100) / 100;
    return rounded.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

export const formatACFT = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = Number(value);
    if (isNaN(num)) return value;
    const rounded = Math.round(num * 100) / 100;
    return rounded.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

export const getDiversionSign = (diversionType) => {
    const type = (diversionType || '').toLowerCase();
    switch (type) {
        case 'transfer in':
        case 'withdrawal':
            return 1;
        case 'delivery':
        case 'return':
        case 'transfer out':
        default:
            return -1;
    }
};

export const isWholesaleType = (type) => {
    const t = (type || '').toLowerCase();
    return t === 'transfer out' || t === 'return';
};
